import { css, Theme } from '@emotion/react';

export type TabVariant = 'small' | 'large';

export const root =
  (variant: TabVariant, numTabs: number) => (theme: Theme) => css`
    position: relative;
    display: flex;
    width: 100%;
    margin: 0;
    padding: 0;
    margin-bottom: ${variant === 'large' ? '0' : '6px'};
    padding-bottom: 3px;
    list-style-type: none;

    &::before {
      content: '';
      display: block;
      position: absolute;
      height: 2px;
      width: 100%;
      bottom: 0;
      left: 0;
      background: ${theme.dove};
    }
  `;

export const tab =
  (variant: TabVariant, isSelected: boolean) => (theme: Theme) => css`
    display: flex;
    position: relative;
    font-size: ${variant === 'large' ? '16px' : '14px'};
    font-weight: 700;
    text-align: left;
    align-items: center;
    justify-content: flex-start;
    color: ${isSelected ? `${theme.deepOcean}` : `${theme.midnight}`};
    padding: ${variant === 'large' ? '12px' : '6px'};
    flex: 1;

    &::after {
      content: '';
      display: ${isSelected ? 'block' : 'none'};
      position: absolute;
      height: 2px;
      width: 100%;
      bottom: -3px;
      left: 0;
      background: ${theme.deepOcean};
    }

    &:disabled {
      cursor: not-allowed;
      color: ${theme.midGrey};
    }
  `;
